import React from 'react';
import './Styles.css';
import PrimaryButton from '../../../../../Elements/ids/Buttons/PrimaryButton';
import { isButtonEnabled } from './Functions';
import { useTeamPageContext } from '../../../TeamPage';
import { teamPageReducerTypes } from '../../../Reducer';
import { modalType } from '../../../OpenedModalType';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import { useLegalUnitName } from '../../../../../Helpers/CustomHooks';

const CreateAgentButton = ({ team }) => {
  const { teamPageDispatch } = useTeamPageContext();
  const legalUnitName = useLegalUnitName(team);

  return (
    <div className="teamPage-newAgentButton-container">
      <img aria-hidden src="/assets/headphones-mic.svg" alt="New agent" />
      <h3>{formatMessage(Messages.activeAgents_addAgentCode)}</h3>

      <PrimaryButton
        text={formatMessage(Messages.common_create)}
        onClickEvent={() => {
          teamPageDispatch({
            type: teamPageReducerTypes.setOpenedModal,
            payload: { modalType: modalType.AgentInfo, modalMode: {} },
          });
        }}
        disabled={!isButtonEnabled(team, legalUnitName)}
      />
    </div>
  );
};

export default CreateAgentButton;
